import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./css/App.css";
import "./css/styles.css";
import Landing from "./Landing";
import Register from "./register/Register";
import Password from "./register/Password";
import Confirmar from "./register/Confirmar";
import PrivacyPolicy from "./register/PrivacyPolicy";
import Login from "./Login";
import RestaurarContrasena from "./RestaurarContrasena";
import Sidebar from "./components/Sidebar";

// Pages
import Dashboard from "./pages/Dashboard";
import Pruebas from "./pages/Pruebas";
import Expedientes from "./pages/Expedientes";

import Marytemp from "./pages/Marytemp";

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas (sin sidebar) */}
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
        <Route path="/confirmar" element={<Confirmar />} />
        <Route path="/password" element={<Password />} />
        <Route path="/login" element={<Login />} />
        <Route path="/restaurar-contrasena" element={<RestaurarContrasena />} />
        
        {/* Rutas privadas (con sidebar) */}
        <Route path="/dashboard" element={<Sidebar><Dashboard /></Sidebar>} />
        <Route path="/pruebas" element={<Sidebar><Pruebas /></Sidebar>} />
        <Route path="/expedientes" element={<Sidebar><Expedientes /></Sidebar>} />

        <Route path="/Marytemp" element={<Marytemp/>} />
        
        {/* Ruta por defecto - redirige a landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;